import React, { useEffect, useState } from 'react';
import {
  getSgsstEventos, getSgsstEvento, crearSgsstEvento, editarSgsstEvento, borrarSgsstEvento,
  getSgsstEmpleados, crearSgsstAccion, editarSgsstAccion, borrarSgsstAccion,
} from '../services/api';
import SgsstTabs from '../components/SgsstTabs';

const fdate = (d) => d ? new Date(d).toLocaleDateString('es-CO') : '—';
const TIPO = { accidente: 'Accidente', incidente: 'Incidente', casi_accidente: 'Casi-accidente' };
const SEV = { sin_lesion: { l: 'Sin lesión', c: '#94a3b8' }, leve: { l: 'Leve', c: '#10b981' }, grave: { l: 'Grave', c: '#f59e0b' }, mortal: { l: 'Mortal', c: '#ef4444' } };
const EST = { reportado: { l: 'Reportado', c: '#94a3b8' }, investigacion: { l: 'En investigación', c: '#3b82f6' }, cerrado: { l: 'Cerrado', c: '#10b981' } };
const METOD = [['5porques', '5 porqués'], ['espina_pescado', 'Espina de pescado'], ['arbol_causas', 'Árbol de causas'], ['otro', 'Otro']];
const VACIO = { tipo: 'accidente', empleado_id: '', afectado_nombre: '', afectado_doc: '', afectado_cargo: '', clasif_trabajador: 'propio',
  fecha_evento: new Date().toISOString().slice(0, 10), hora_evento: '', lugar: '', proceso_area: '', descripcion: '',
  tipo_lesion: '', parte_cuerpo: '', agente: '', mecanismo: '', dias_incapacidad: 0, severidad: 'leve', reportado_arl: false, fecha_reporte_arl: '', estado: 'reportado',
  inv_fecha: '', inv_equipo: '', inv_metodologia: '5porques', inv_causas_inmediatas: '', inv_causas_basicas: '', inv_causa_raiz: '', inv_lecciones: '' };

export default function SgsstEventos() {
  const [lista, setLista] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [modal, setModal] = useState(null);   // { id?, form, acciones }
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => getSgsstEventos().then(r => setLista(r.data)).catch(() => {});
  useEffect(() => { load(); getSgsstEmpleados().then(r => setEmpleados(r.data)).catch(() => {}); }, []);
  const flash = (ok, text) => { setMsg({ ok, text }); setTimeout(() => setMsg(null), 4000); };

  const abrirNuevo = () => setModal({ form: { ...VACIO }, acciones: [] });
  const abrirEditar = async (ev) => {
    try { const { data } = await getSgsstEvento(ev.id);
      setModal({ id: ev.id, form: { ...VACIO, ...data, fecha_evento: (data.fecha_evento || '').slice(0, 10), inv_fecha: (data.inv_fecha || '').slice(0, 10) || '', fecha_reporte_arl: (data.fecha_reporte_arl || '').slice(0, 10) || '' }, acciones: data.acciones || [] });
    } catch (e) { flash(false, 'No se pudo abrir'); }
  };

  const guardar = async () => {
    const f = modal.form;
    if (!f.fecha_evento) return flash(false, 'La fecha del evento es requerida');
    if (!f.empleado_id && !f.afectado_nombre?.trim()) return flash(false, 'Indica el trabajador afectado');
    setBusy(true);
    try {
      if (modal.id) { await editarSgsstEvento(modal.id, f); flash(true, '✅ Guardado'); setModal(null); }
      else { const { data } = await crearSgsstEvento(f); flash(true, '✅ Evento registrado — ahora puedes agregar planes de acción'); setModal({ id: data.id, form: { ...VACIO, ...data, fecha_evento: (data.fecha_evento || '').slice(0, 10) }, acciones: [] }); }
      load();
    } catch (err) { flash(false, '❌ ' + (err.response?.data?.error || 'No se pudo guardar')); }
    finally { setBusy(false); }
  };
  const eliminar = async (ev) => {
    if (!window.confirm(`¿Eliminar el evento #${ev.consecutivo}? También se borran sus acciones.`)) return;
    try { await borrarSgsstEvento(ev.id); load(); } catch (e) { flash(false, 'No se pudo eliminar'); }
  };

  return (
    <div style={s.wrap}>
      <SgsstTabs />
      <div style={s.head}>
        <div>
          <h1 style={s.h1}>Accidentes e incidentes</h1>
          <p style={s.sub}>Reporte, investigación (Res. 1401/2007) y planes de acción.</p>
        </div>
        <button style={s.btn} onClick={abrirNuevo}>+ Reportar evento</button>
      </div>
      {msg && <div style={{ ...s.msg, background: msg.ok ? '#064e3b' : '#450a0a', color: msg.ok ? '#6ee7b7' : '#fca5a5' }}>{msg.text}</div>}

      <div style={s.card}>
        <div style={{ overflowX: 'auto' }}>
          <table style={s.table}>
            <thead><tr>{['#', 'Tipo', 'Afectado', 'Fecha', 'Días inc.', 'Severidad', 'Estado', 'Acciones', ''].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
            <tbody>
              {lista.length === 0 && <tr><td colSpan={9} style={s.empty}>Sin eventos registrados.</td></tr>}
              {lista.map(e => {
                const sev = SEV[e.severidad] || SEV.leve, est = EST[e.estado] || EST.reportado;
                return (
                  <tr key={e.id}>
                    <td style={{ ...s.td, fontFamily: 'ui-monospace' }}>{e.consecutivo}</td>
                    <td style={s.td}>{TIPO[e.tipo] || e.tipo}</td>
                    <td style={{ ...s.td, color: '#e2e8f0' }}>{e.afectado_nombre || '—'}</td>
                    <td style={s.td}>{fdate(e.fecha_evento)}</td>
                    <td style={{ ...s.td, textAlign: 'center' }}>{e.dias_incapacidad || 0}</td>
                    <td style={s.td}><span style={{ ...s.badge, background: sev.c + '22', color: sev.c }}>{sev.l}</span></td>
                    <td style={s.td}><span style={{ ...s.badge, background: est.c + '22', color: est.c }}>{est.l}</span></td>
                    <td style={{ ...s.td, textAlign: 'center' }}>{e.acciones || 0}</td>
                    <td style={s.td}>
                      <button style={s.link} onClick={() => abrirEditar(e)}>Abrir</button>
                      <button style={{ ...s.link, color: '#fca5a5' }} onClick={() => eliminar(e)}>Eliminar</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {modal && <EventoModal modal={modal} setModal={setModal} empleados={empleados} guardar={guardar} busy={busy} flash={flash} reload={load} />}
    </div>
  );
}

function EventoModal({ modal, setModal, empleados, guardar, busy, flash, reload }) {
  const f = modal.form;
  const set = (k, v) => setModal({ ...modal, form: { ...f, [k]: v } });
  const [tab, setTab] = useState('datos');
  const [na, setNa] = useState({ descripcion: '', tipo: 'correctiva', responsable_nombre: '', fecha_planeada: '' });

  const pickEmpleado = (id) => {
    const emp = empleados.find(e => e.id === id);
    if (emp) setModal({ ...modal, form: { ...f, empleado_id: id, afectado_nombre: emp.nombre, afectado_doc: emp.numero_documento, afectado_cargo: emp.cargo || '' } });
    else setModal({ ...modal, form: { ...f, empleado_id: '' } });
  };

  const addAccion = async () => {
    if (!na.descripcion.trim()) return flash(false, 'Describe la acción');
    try {
      const { data } = await crearSgsstAccion({ ...na, origen_tipo: 'evento', origen_id: modal.id });
      setModal({ ...modal, acciones: [...modal.acciones, data] });
      setNa({ descripcion: '', tipo: 'correctiva', responsable_nombre: '', fecha_planeada: '' });
      reload();
    } catch (e) { flash(false, 'No se pudo crear la acción'); }
  };
  const toggleAccion = async (a) => {
    const estado = a.estado === 'cerrada' ? 'abierta' : 'cerrada';
    try { const { data } = await editarSgsstAccion(a.id, { ...a, estado, fecha_cierre: estado === 'cerrada' ? new Date().toISOString().slice(0, 10) : null });
      setModal({ ...modal, acciones: modal.acciones.map(x => x.id === a.id ? data : x) }); reload();
    } catch (e) { flash(false, 'No se pudo actualizar'); }
  };
  const delAccion = async (a) => {
    try { await borrarSgsstAccion(a.id); setModal({ ...modal, acciones: modal.acciones.filter(x => x.id !== a.id) }); reload(); }
    catch (e) { flash(false, 'No se pudo eliminar'); }
  };

  return (
    <div style={s.overlay} onClick={() => setModal(null)}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <h3 style={s.modalTitle}>{modal.id ? `Evento #${f.consecutivo || ''}` : 'Reportar evento'}</h3>
        <div style={s.mtabs}>
          {[['datos', 'Datos del evento'], ['clasif', 'Clasificación'], ['inv', 'Investigación'], ['acc', `Acciones${modal.acciones?.length ? ` (${modal.acciones.length})` : ''}`]].map(([k, l]) =>
            <button key={k} onClick={() => setTab(k)} style={{ ...s.mtab, ...(tab === k ? s.mtabOn : {}) }}>{l}</button>)}
        </div>

        {tab === 'datos' && <>
          <Grid>
            <F l="Tipo de evento"><select style={s.in} value={f.tipo} onChange={e => set('tipo', e.target.value)}>{Object.entries(TIPO).map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></F>
            <F l="Clasificación del trabajador"><select style={s.in} value={f.clasif_trabajador} onChange={e => set('clasif_trabajador', e.target.value)}>{['propio', 'contratista', 'temporal', 'otro'].map(o => <option key={o} value={o}>{o}</option>)}</select></F>
          </Grid>
          <F l="Trabajador (de la lista o manual)">
            <select style={s.in} value={f.empleado_id || ''} onChange={e => pickEmpleado(e.target.value)}>
              <option value="">— Externo / manual —</option>
              {empleados.map(e => <option key={e.id} value={e.id}>{e.nombre} · {e.numero_documento}</option>)}
            </select>
          </F>
          <Grid3>
            <F l="Nombre afectado"><input style={s.in} value={f.afectado_nombre} onChange={e => set('afectado_nombre', e.target.value)} /></F>
            <F l="Documento"><input style={s.in} value={f.afectado_doc} onChange={e => set('afectado_doc', e.target.value)} /></F>
            <F l="Cargo"><input style={s.in} value={f.afectado_cargo} onChange={e => set('afectado_cargo', e.target.value)} /></F>
          </Grid3>
          <Grid3>
            <F l="Fecha"><input type="date" style={s.in} value={f.fecha_evento} onChange={e => set('fecha_evento', e.target.value)} /></F>
            <F l="Hora"><input type="time" style={s.in} value={f.hora_evento || ''} onChange={e => set('hora_evento', e.target.value)} /></F>
            <F l="Lugar"><input style={s.in} value={f.lugar} onChange={e => set('lugar', e.target.value)} /></F>
          </Grid3>
          <F l="Proceso / área"><input style={s.in} value={f.proceso_area} onChange={e => set('proceso_area', e.target.value)} /></F>
          <F l="Descripción de lo ocurrido"><textarea style={s.ta} value={f.descripcion} onChange={e => set('descripcion', e.target.value)} /></F>
        </>}

        {tab === 'clasif' && <>
          <Grid>
            <F l="Tipo de lesión"><input style={s.in} value={f.tipo_lesion} onChange={e => set('tipo_lesion', e.target.value)} /></F>
            <F l="Parte del cuerpo"><input style={s.in} value={f.parte_cuerpo} onChange={e => set('parte_cuerpo', e.target.value)} /></F>
          </Grid>
          <Grid>
            <F l="Agente"><input style={s.in} value={f.agente} onChange={e => set('agente', e.target.value)} /></F>
            <F l="Mecanismo"><input style={s.in} value={f.mecanismo} onChange={e => set('mecanismo', e.target.value)} /></F>
          </Grid>
          <Grid3>
            <F l="Días de incapacidad"><input type="number" style={s.in} value={f.dias_incapacidad} onChange={e => set('dias_incapacidad', +e.target.value)} /></F>
            <F l="Severidad"><select style={s.in} value={f.severidad} onChange={e => set('severidad', e.target.value)}>{Object.entries(SEV).map(([v, o]) => <option key={v} value={v}>{o.l}</option>)}</select></F>
            <F l="Estado"><select style={s.in} value={f.estado} onChange={e => set('estado', e.target.value)}>{Object.entries(EST).map(([v, o]) => <option key={v} value={v}>{o.l}</option>)}</select></F>
          </Grid3>
          <Grid>
            <F l="¿Reportado a la ARL?"><select style={s.in} value={f.reportado_arl ? '1' : '0'} onChange={e => set('reportado_arl', e.target.value === '1')}><option value="0">No</option><option value="1">Sí</option></select></F>
            <F l="Fecha de reporte ARL"><input type="date" style={s.in} value={f.fecha_reporte_arl || ''} onChange={e => set('fecha_reporte_arl', e.target.value)} /></F>
          </Grid>
        </>}

        {tab === 'inv' && <>
          <Grid>
            <F l="Fecha de investigación"><input type="date" style={s.in} value={f.inv_fecha || ''} onChange={e => set('inv_fecha', e.target.value)} /></F>
            <F l="Metodología"><select style={s.in} value={f.inv_metodologia} onChange={e => set('inv_metodologia', e.target.value)}>{METOD.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></F>
          </Grid>
          <F l="Equipo investigador"><input style={s.in} value={f.inv_equipo} onChange={e => set('inv_equipo', e.target.value)} /></F>
          <F l="Causas inmediatas (actos y condiciones subestándar)"><textarea style={s.ta} value={f.inv_causas_inmediatas} onChange={e => set('inv_causas_inmediatas', e.target.value)} /></F>
          <F l="Causas básicas (factores personales y del trabajo)"><textarea style={s.ta} value={f.inv_causas_basicas} onChange={e => set('inv_causas_basicas', e.target.value)} /></F>
          <F l="Causa raíz"><textarea style={s.ta} value={f.inv_causa_raiz} onChange={e => set('inv_causa_raiz', e.target.value)} /></F>
          <F l="Lecciones aprendidas"><textarea style={s.ta} value={f.inv_lecciones} onChange={e => set('inv_lecciones', e.target.value)} /></F>
        </>}

        {tab === 'acc' && <>
          {!modal.id ? <div style={s.hint}>Guarda el evento primero para agregar planes de acción.</div> : <>
            <div style={s.accList}>
              {modal.acciones.length === 0 && <div style={s.hint}>Sin acciones todavía.</div>}
              {modal.acciones.map(a => (
                <div key={a.id} style={s.accItem}>
                  <input type="checkbox" checked={a.estado === 'cerrada'} onChange={() => toggleAccion(a)} />
                  <div style={{ flex: 1 }}>
                    <div style={{ color: a.estado === 'cerrada' ? '#64748b' : '#e2e8f0', textDecoration: a.estado === 'cerrada' ? 'line-through' : 'none', fontSize: 13 }}>{a.descripcion}</div>
                    <div style={s.accMeta}>{a.tipo} · {a.responsable_nombre || 'sin responsable'} · {a.fecha_planeada ? fdate(a.fecha_planeada) : 'sin fecha'}</div>
                  </div>
                  <button style={{ ...s.link, color: '#fca5a5' }} onClick={() => delAccion(a)}>✕</button>
                </div>
              ))}
            </div>
            <div style={s.sec}>Nueva acción</div>
            <F l="Descripción"><input style={s.in} value={na.descripcion} onChange={e => setNa({ ...na, descripcion: e.target.value })} /></F>
            <Grid3>
              <F l="Tipo"><select style={s.in} value={na.tipo} onChange={e => setNa({ ...na, tipo: e.target.value })}>{['correctiva', 'preventiva', 'mejora'].map(o => <option key={o} value={o}>{o}</option>)}</select></F>
              <F l="Responsable"><input style={s.in} value={na.responsable_nombre} onChange={e => setNa({ ...na, responsable_nombre: e.target.value })} /></F>
              <F l="Fecha límite"><input type="date" style={s.in} value={na.fecha_planeada} onChange={e => setNa({ ...na, fecha_planeada: e.target.value })} /></F>
            </Grid3>
            <button style={{ ...s.btn, padding: '8px 14px', fontSize: 13 }} onClick={addAccion}>+ Agregar acción</button>
          </>}
        </>}

        <div style={s.modalBtns}>
          <button style={s.btnGhost} onClick={() => setModal(null)}>Cerrar</button>
          {tab !== 'acc' && <button style={s.btn} disabled={busy} onClick={guardar}>{busy ? 'Guardando…' : (modal.id ? 'Guardar cambios' : 'Registrar evento')}</button>}
        </div>
      </div>
    </div>
  );
}

const F = ({ l, children }) => <div style={{ marginBottom: 10 }}><label style={s.lbl}>{l}</label>{children}</div>;
const Grid = ({ children }) => <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>{children}</div>;
const Grid3 = ({ children }) => <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(140px,1fr))', gap: 12 }}>{children}</div>;

const s = {
  wrap: { padding: 4 },
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16, flexWrap: 'wrap', gap: 12 },
  h1: { color: '#f1f5f9', fontSize: 24, fontWeight: 700, margin: '0 0 4px' },
  sub: { color: '#64748b', fontSize: 14, margin: 0 },
  btn: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnGhost: { background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '10px 18px', fontSize: 14, cursor: 'pointer' },
  msg: { padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 14 },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: 760 },
  th: { textAlign: 'left', padding: '10px 12px', color: '#64748b', fontSize: 11, textTransform: 'uppercase', letterSpacing: .5, borderBottom: '1px solid #334155', background: '#0f172a', whiteSpace: 'nowrap' },
  td: { padding: '10px 12px', color: '#94a3b8', borderBottom: '1px solid #1e293b' },
  empty: { padding: 30, textAlign: 'center', color: '#64748b' },
  badge: { padding: '2px 9px', borderRadius: 20, fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' },
  link: { background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: 13, marginRight: 10, padding: 0 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modal: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 18, width: 660, maxWidth: '96vw', maxHeight: '92vh', overflowY: 'auto' },
  modalTitle: { color: '#f1f5f9', fontSize: 18, fontWeight: 700, margin: '0 0 12px' },
  modalBtns: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 18 },
  mtabs: { display: 'flex', gap: 4, marginBottom: 16, borderBottom: '1px solid #334155', flexWrap: 'wrap' },
  mtab: { padding: '7px 13px', background: 'none', border: 'none', color: '#94a3b8', fontSize: 13, fontWeight: 600, cursor: 'pointer', borderBottom: '2px solid transparent', marginBottom: -1 },
  mtabOn: { color: '#f1f5f9', borderBottom: '2px solid #f59e0b' },
  lbl: { display: 'block', color: '#94a3b8', fontSize: 12, marginBottom: 4 },
  in: { width: '100%', boxSizing: 'border-box', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 11px', color: '#f1f5f9', fontSize: 13.5 },
  ta: { width: '100%', boxSizing: 'border-box', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 11px', color: '#f1f5f9', fontSize: 13.5, minHeight: 54, resize: 'vertical', fontFamily: 'inherit' },
  sec: { color: '#f59e0b', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: .6, margin: '16px 0 10px', paddingBottom: 5, borderBottom: '1px solid #334155' },
  hint: { color: '#64748b', fontSize: 13, padding: '10px 0' },
  accList: { display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 6 },
  accItem: { display: 'flex', alignItems: 'flex-start', gap: 10, background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '9px 12px' },
  accMeta: { color: '#64748b', fontSize: 11, marginTop: 2 },
};
